const initialState = { collection: null };

function analyticsOnePagerReducer(state = initialState, action) {
    if (
        action.type === 'LOGOUT_REQUEST' ||
        action.type === 'AUTHENTICATE_REQUEST' ||
        action.type === 'ANALYTICS_ONE_PAGER_REQUEST'
    ) {
        return initialState;
    }

    if (action.type === 'ANALYTICS_ONE_PAGER_SUCCESS') {
        return action.payload;
    }

    return state;
}

export default analyticsOnePagerReducer;
